import api from "@/lib/api";
import { useQuery } from "@tanstack/react-query";

const DeveloperPage = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["developer-data"],
    queryFn: async () => {
      try {
        const response = await api.get("/user/me");
        return response.data;
      } catch (error) {
        console.error("Error fetching developer data:", error);
        throw error;
      }
    },
  });

  if (isLoading) {
    return <div>Cargado...</div>;
  }

  if (error) {
    return <div>Error: {(error as Error).message}</div>;
  }

  if (data) {
    return (
      <div className="py-20">
        <div className="max-w-md mx-auto bg-white rounded-2xl shadow-md p-6 border border-gray-100">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Información del usuario
          </h2>

          <div className="space-y-3">
            <div>
              <p className="text-sm text-gray-500">Nombre</p>
              <p className="text-base font-medium text-gray-900">{data.name}</p>
            </div>

            <div>
              <p className="text-sm text-gray-500">Email</p>
              <p className="text-base font-medium text-gray-900">
                {data.email}
              </p>
            </div>

            <div>
              <p className="text-sm text-gray-500">ID empleado</p>
              <p className="text-base font-medium text-gray-900">
                {data.payrollNumber}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default DeveloperPage;
